//@flow
import React, { useEffect, useState } from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { Image } from 'components/atoms/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CallToAction } from 'components/atoms/callToAction';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  heading?: string,
  subHeading?: string,
  description?: string,
};

const Foundation = (props: Props) => {
  const { cmsDetailsData } = props;
  const {
    heading,
    subHeading,
    description,
    image_web,
    tagWord,
  } = props.data.foundationSection[0];
  const [selected_heading, set_selected_heading] = useState('');
  const [selected_title, set_selected_title] = useState('');
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [overlay_page_data, set_overlay_page_data] = useState({});
  useEffect(() => {
    if (cmsDetailsData) {
      checkOverlayCorrespondingFeature();
    }
  }, [selected_heading]);
  const mediaPath = `${props.mediaPath}${'/web'}`;
  const checkOverlayCorrespondingFeature = () => {
    let overlaydata = {};
    set_overlay_page_data(overlaydata);
    Object.values(cmsDetailsData).map((cmsdata, idx) => {
      if (heading === cmsdata.page_title) {
        set_overlay_page_data(cmsdata);
        set_selected_title(cmsdata.page_title);
        return;
      }
    });
  };
  const handleLearnMore = heading => {
    set_selected_heading(heading);
    checkOverlayCorrespondingFeature();
    setshowDescriptionLayout(true);
  };

  const handleClick = () => {
    console.log('');
  };
  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'leadership-overlay'}
        openFor={'leadership'}
        className={'ourHomesOverlay'}
        mediaPath={mediaPath}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: RouteNames.musicEvents,
          },
          {
            breadcrumbName: 'Music Foundation',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'main-section'}>
      <Row className={'main-row'}>
        <Col
          className={'left-section'}
          xs={{ span: 11 }}
          md={{ span: 3, offset: 0 }}
        >
          <h3 className={'subHeadingClassName'}>{tagWord}</h3>
          <h1 className={'headingClassName'}>{heading}</h1>
          <div className={'description'}>
            <HTMLView
              className={'descriptionClassName'}
              html={description}
              tagName={'p'}
            />
          </div>
          {props.showOverlay === true && heading === selected_title ? (
            <div>
              <CallToAction
                text={'Learn More'}
                onClick={() => handleLearnMore(heading)}
                className={'learn-more'}
              />
            </div>
          ) : null}
          {props.type === 'restaurant' && (
            <a href={'#contact'}>
              <CallToAction
                text={'Contact Us'}
                onClick={() => handleClick()}
                className={'learn-more'}
                mode={'dark'}
              />
            </a>
          )}
        </Col>
        <Col md={{ span: 8, offset: 1 }} className={'right-section'}>
          <Image
            src={image_web}
            alt={'FoundationPic'}
            className={'foundation-image'}
          />
        </Col>
      </Row>
      {showOverlay}
    </div>
  );
};
export default Foundation;
